module.exports = "/_next/static/images/919521309239770de20ad4b761224ef5-listen-circle.svg.webp";